import { makeMultiCurrencyFetchKey, makeMultiCurrencyFetchUrl } from './cacheKeys';
import { withQuickFetch } from './withQuickFetch';
export const fetchPortalCurrencies = ({
  httpClient
}) => withQuickFetch({
  requestName: makeMultiCurrencyFetchKey({}),
  baseFetch: () => httpClient.get(makeMultiCurrencyFetchUrl())
});